import React, { useState, useEffect } from "react";
import "./NewPatientRegistration.css";

const PostAppointment = ({ screenAction,triggerSave }) => {
  const [isDisabled, setIsDisabled] = useState(true);
  const [searchText, setSearchText] = useState("");
  const [appointments, setAppointments] = useState([]);
  const [showDropdown, setShowDropdown] = useState(false);
  const [patientSearch, setPatientSearch] = useState("");
const [patientList, setPatientList] = useState([]);
const [showPatientDropdown, setShowPatientDropdown] = useState(false);

  const initialFormState = {
    patient_id: "",
    appointment_id: "",
    recommended_tests: "",

    next_visit_date: "",
  };

    const [formData, setFormData] = useState(initialFormState);

  const [medicalFiles, setMedicalFiles] = useState([])

  const handleFileChange = (e) => {
  const files = Array.from(e.target.files);
  const filesWithPreview = files.map(file => ({
    file,
    preview: URL.createObjectURL(file),
    isExisting: false
  }));
  setMedicalFiles(prev => [...prev, ...filesWithPreview]);
};

const removeFile = (index) => {
  const updated = [...medicalFiles];
  updated.splice(index, 1);
  setMedicalFiles(updated);
};



  // 🔎 Search Appointments when Edit/View
const searchAppointments = async (text) => {
  setSearchText(text);

  if (text.length < 2) {
    setAppointments([]);
    return;
  }

  const user = JSON.parse(localStorage.getItem("user"));

  const res = await fetch(
    `https://hmsapi.emedhatechnologies.com/master/api/api/post-appointments/search?q=${text}&employee_id=${user.id}`
  );

  const data = await res.json();

  setAppointments(data);
  setShowDropdown(true);
};


const searchPatients = async (text) => {
  setPatientSearch(text);

  if (!text) {
    setPatientList([]);
    setShowPatientDropdown(false);
    return;
  }

  if (text.length < 2) return;

  const user = JSON.parse(localStorage.getItem("user"));

  const res = await fetch(
    `https://hmsapi.emedhatechnologies.com/master/api/api/search?q=${text}&employee_id=${user.id}`
  );

  const data = await res.json();

  setPatientList(data);
  setShowPatientDropdown(true);
};

const selectPatient = async (p) => {
  const user = JSON.parse(localStorage.getItem("user"));

  setPatientSearch(`${p.patient_id} | ${p.name} | ${p.mobile}`);
  setShowPatientDropdown(false);

  try {
    const res = await fetch(
      `https://hmsapi.emedhatechnologies.com/master/api/appointments/latest/${p.patient_id}?employee_id=${user.id}`
    );

    if (!res.ok) {
      alert("No appointments found for this patient");
      return;
    }

    const appt = await res.json();

    // ✅ Fill form with latest appointment
    setFormData((prev) => ({
      ...prev,
      patient_id: p.patient_id,
      appointment_id: appt.appointment_id
    }));

  } catch (err) {
    console.error(err);
  }
};


useEffect(() => {
  if (triggerSave > 0 && screenAction === "save") {
    handleSubmit();
  }
}, [triggerSave]);


const selectAppointment = async (appointment) => {

  // 🔥 Try to fetch existing post data
  const res = await fetch(
    `https://hmsapi.emedhatechnologies.com/master/api/api/post-appointment/${appointment.appointment_id}`
  );

  const existing = await res.json();

  if (existing && existing.appointment_id) {
   setFormData({
      ...existing,
      // ✅ Convert the ISO string to IST YYYY-MM-DD for the date input
      next_visit_date: formatToISTDate(existing.next_visit_date)
    });
 // Parse existing files
    if (existing.doctor_prescription_file) {
      const fileList = JSON.parse(existing.doctor_prescription_file);
      const formatted = fileList.map(fileName => ({
        file: null,
        preview: fileName.startsWith('http') ? fileName : `${fileName}`,
        isExisting: true,
        fileName: fileName
      }));
      setMedicalFiles(formatted);
    }
  } else {
    setFormData({ ...initialFormState, appointment_id: appointment.appointment_id, patient_id: appointment.patient_id });
    setMedicalFiles([]);
  }

  setSearchText(
    `${appointment.patient_name} | ${appointment.patient_id} | ${appointment.appointment_id}`
  );

  setShowDropdown(false);

  if (screenAction === "edit") setIsDisabled(false);
  if (screenAction === "view") setIsDisabled(true);
};



  // 🔄 Actions
const clearForm = () => {
  setFormData(initialFormState);
  setSearchText("");
  setAppointments([]);
  setShowDropdown(false);
};

  const enableEditing = () => setIsDisabled(false);
  const disableEditing = () => setIsDisabled(true);

  const refreshForm = () => {
    if (formData.appointment_id) {
      selectAppointment(formData);
    } else {
      clearForm();
    }
  };

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    if (files) setFormData({ ...formData, [name]: files[0] });
    else setFormData({ ...formData, [name]: value });
  };

  // const handleSubmit = async () => {
  //   if (screenAction === "add") {
  //     await fetch("/api/post-appointments", {
  //       method: "POST",
  //       headers: { "Content-Type": "application/json" },
  //       body: JSON.stringify(formData),
  //     });
  //   }
  //   if (screenAction === "edit") {
  //     await fetch(`/api/post-appointments/${formData.appointment_id}`, {
  //       method: "PUT",
  //       headers: { "Content-Type": "application/json" },
  //       body: JSON.stringify(formData),
  //     });
  //   }
  //   alert("Post Appointment Saved");
  // };

// const handleSubmit = async () => {
//   const user = JSON.parse(localStorage.getItem("user"));

//   if (!formData.appointment_id) {
//     alert("Select appointment");
//     return;
//   }

//   const payload = { ...formData };

//   delete payload.created_at;
//   delete payload.updated_at;

//   payload.created_by = user.id;

//   const method = formData.id ? "PUT" : "POST";

//   const url =
//     method === "POST"
//       ? "https://hmsapi.emedhatechnologies.com/master/api/api/post-appointment"
//       : `https://hmsapi.emedhatechnologies.com/master/api/api/post-appointment/${formData.appointment_id}`;

//   const res = await fetch(url, {
//     method,
//     headers: { "Content-Type": "application/json" },
//     body: JSON.stringify(payload)
//   });

//   if (res.ok) {
//     alert("Saved Successfully");
//     clearForm();
//   }
// };


const handleSubmit = async () => {
  const user = JSON.parse(localStorage.getItem("user"));
  if (!formData.appointment_id) return alert("Select appointment");

  const formDataObj = new FormData();
  const payload = { ...formData };
  
  delete payload.created_at;
  delete payload.updated_at;
  payload.created_by = user.id;

  // Append text fields
  Object.keys(payload).forEach(key => formDataObj.append(key, payload[key] || ""));

  // ✅ Handle Files (New vs Existing)
  const existingFileNames = medicalFiles.filter(f => f.isExisting).map(f => f.fileName);
  formDataObj.append("existing_files", JSON.stringify(existingFileNames));
  
  medicalFiles.forEach(item => {
    if (!item.isExisting) formDataObj.append("medical_files", item.file);
  });

  const method = formData.id ? "PUT" : "POST";
  const url = method === "POST" 
    ? "https://hmsapi.emedhatechnologies.com/master/api/api/post-appointment" 
    : `https://hmsapi.emedhatechnologies.com/master/api/api/post-appointment/${formData.appointment_id}`;

  const res = await fetch(url, { method, body: formDataObj });
  if (res.ok) {
    alert("Post Appointment Saved");
    clearForm();
    setMedicalFiles([]);
  }
};

const formatToISTDate = (utcString) => {
  if (!utcString) return "";
  
  // Create a date object from the UTC string
  const date = new Date(utcString);
  
  // Shift to IST (UTC + 5:30) manually or use Intl for reliability
  // This ensures the date doesn't "jump" back a day due to UTC 00:00
  return new Intl.DateTimeFormat('en-CA', {
    timeZone: 'Asia/Kolkata',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).format(date); // Returns YYYY-MM-DD in IST
};


 const printForm = () => {
  const newWindow = window.open("", "", "width=900,height=700");
  const today = new Date().toLocaleDateString();

  const htmlContent = `
    <html>
      <head>
        <title>Clinical Summary - ${formData.appointment_id}</title>
        <style>
          body { font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; color: #333; margin: 0; padding: 40px; }
          
          /* Header Section */
          .header { display: flex; justify-content: space-between; align-items: center; border-bottom: 2px solid #2980b9; padding-bottom: 10px; margin-bottom: 20px; }
          .hospital-info h1 { margin: 0; color: #2c3e50; font-size: 24px; text-transform: uppercase; }
          .hospital-info p { margin: 2px 0; font-size: 12px; color: #7f8c8d; }
          .report-title { text-align: right; }
          .report-title h2 { margin: 0; color: #2980b9; font-size: 18px; }
          
          /* Section Styling */
          .section-header { background: #f2f7fb; padding: 8px 12px; font-weight: bold; font-size: 14px; border-left: 4px solid #2980b9; margin-top: 20px; margin-bottom: 10px; text-transform: uppercase; }
          
          /* Data Grid */
          .data-grid { display: grid; grid-template-columns: repeat(2, 1fr); gap: 10px; margin-bottom: 10px; }
          .data-item { font-size: 13px; display: flex; border-bottom: 1px dotted #ccc; padding: 6px 0; }
          .label { font-weight: 600; width: 160px; color: #555; }
          .value { flex: 1; color: #000; font-weight: 500; }
          .full-width { grid-column: span 2; }

          /* Prescription Images */
          .image-gallery { display: flex; gap: 10px; margin-top: 10px; flex-wrap: wrap; }
          .image-box { border: 1px solid #ddd; padding: 5px; border-radius: 5px; }
          .image-box img { width: 150px; height: auto; border-radius: 3px; }

          .footer { margin-top: 50px; font-size: 10px; text-align: center; color: #95a5a6; border-top: 1px solid #eee; padding-top: 10px; }
          .sig-box { margin-top: 60px; display: flex; justify-content: space-between; }
          .sig { border-top: 1px solid #000; width: 200px; text-align: center; padding-top: 5px; font-size: 12px; }

          @media print {
            body { padding: 20px; }
            @page { margin: 0.5cm; }
          }
        </style>
      </head>
      <body>
        <div class="header">
          <div class="hospital-info">
            <h1>EMEDHA CARE HOSPITAL</h1>
            <p>123 Medical Park, Health City - 560001</p>
            <p>Phone: +91 98765 43210 | Email: contact@citycare.com</p>
          </div>
          <div class="report-title">
            <h2>CLINICAL SUMMARY</h2>
            <p>Date: ${today}</p>
          </div>
        </div>

        <div class="section-header">Reference Details</div>
        <div class="data-grid">
          <div class="data-item"><span class="label">Appointment ID:</span> <span class="value">${formData.appointment_id}</span></div>
          <div class="data-item"><span class="label">Patient ID:</span> <span class="value">${formData.patient_id}</span></div>
          <div class="data-item"><span class="label">Patient Name:</span> <span class="value">${formData.patient_name || 'N/A'}</span></div>
          <div class="data-item"><span class="label">Mobile:</span> <span class="value">${formData.mobile || 'N/A'}</span></div>
        </div>

        <div class="section-header">Doctor's Advice & Recommendations</div>
        <div class="data-grid">
          <div class="data-item full-width"><span class="label">Recommended Tests:</span> <span class="value">${formData.recommended_tests || 'No tests recommended'}</span></div>
          <div class="data-item"><span class="label">Next Visit Date:</span> <span class="value" style="color: #e67e22;">${formData.next_visit_date || 'TBD'}</span></div>
        </div>

        <div class="section-header">Uploaded Prescription / Records</div>
        <div class="image-gallery">
          ${medicalFiles.length > 0 
            ? medicalFiles.map(file => `
                <div class="image-box">
                  <img src="${file.preview}" alt="Record" />
                </div>
              `).join('')
            : '<p style="font-size: 12px; color: #7f8c8d;">No digital prescription attached.</p>'
          }
        </div>

        <div class="sig-box">
          <div class="sig">Doctor's Signature</div>
          <div class="sig">Clinic Stamp</div>
        </div>

        <div class="footer">
          This document is a summary of the clinical consultation. 
          Please bring this along with the test reports for the follow-up visit.
        </div>
      </body>
    </html>
  `;

  newWindow.document.write(htmlContent);
  newWindow.document.close();
  
  // Timeout ensures images are rendered before print dialog opens
  setTimeout(() => {
    newWindow.print();
    newWindow.close();
  }, 700);
};
  // 🔔 Trigger actions when screenAction changes
useEffect(() => {

  if (screenAction === "add") {
    clearForm();
    setIsDisabled(false); // wait for search
  }

  if (screenAction === "edit") {
    clearForm();
    setIsDisabled(false);
  }

  if (screenAction === "view") {
    clearForm();
    setIsDisabled(true);
  }

  // if (screenAction === "save") handleSubmit();
  if (screenAction === "refresh") clearForm();
  if (screenAction === "print") printForm();

}, [screenAction]);

  return (
    <div className="post-appointment-container" id="print-area">
      {(screenAction === "edit" || screenAction === "view") && (
        <div className="appointment-search">
          <label>Search Appointment</label>
          <input
            type="text"
            value={searchText}
            placeholder="Search by Patient / Appointment ID"
            onChange={(e) => searchAppointments(e.target.value)}
          />
          {showDropdown && appointments.length > 0 && (
            <div className="appointment-dropdown">
              {appointments.map((a) => (
                <div
                  key={a.appointment_id}
                  className="appointment-item"
                  onClick={() => selectAppointment(a)}
                >
                  {a.patient_name} | {a.patient_id} | {a.appointment_id}
                </div>
              ))}
            </div>
          )}
        </div>
      )}

      <form className="post-appointment-form" >
        <div className="form-section-header">
          <h3>Post Appointment Details</h3>
        </div>

        <div className="form-grid">
          <div className="input-box">
  <label>Patient</label>

  <input
    type="text"
    placeholder="Search Patient ID / Name / Mobile"
    value={patientSearch}
    disabled={isDisabled}
    onChange={(e) => {
      setShowPatientDropdown(true);
      searchPatients(e.target.value);
    }}
  />

  {showPatientDropdown && patientList.length > 0 && (
    <div className="patient-dropdown">
      {patientList.map((p) => (
        <div
          key={p.patient_id}
          className="patient-item"
          onClick={() => selectPatient(p)}
        >
          {p.patient_id} | {p.name} | {p.mobile}

          <span
            style={{
              marginLeft: "10px",
              padding: "2px 8px",
              borderRadius: "12px",
              fontSize: "11px",
              backgroundColor:
                p.source === "BOT" ? "#25D366" : "#3498db",
              color: "#fff"
            }}
          >
            {p.source === "BOT" ? "WhatsApp" : "HMS"}
          </span>
        </div>
      ))}
    </div>
  )}
</div>

          <div className="input-box">
            <label>Appointment ID</label>
            <input
              type="text"
              name="appointment_id"
              value={formData.appointment_id}
                  disabled={isDisabled}
                     onChange={handleChange}
            />
          </div>

          <div className="input-box full-width">
            <label>Recommended Tests</label>
            <input
              type="text"
              name="recommended_tests"
              value={formData.recommended_tests}
              onChange={handleChange}
              disabled={isDisabled}
            />
          </div>

          <div className="input-box">
            <label>Upload Prescription</label>
            <input
              type="file"
              name="doctor_prescription_file"
               multiple
    onChange={handleFileChange}
              disabled={isDisabled}
            />
          </div>

          <div className="preview-container">
  {medicalFiles.map((item, index) => (
    <div key={index} className="preview-box">
      <img src={item.preview} alt="prescription" style={{ width: 100, height: 100, borderRadius: 8 }} />
      {!isDisabled && (
        <button type="button" className="remove-btn" onClick={() => removeFile(index)}>✕</button>
      )}
    </div>
  ))}
</div>


          <div className="input-box">
            <label>Next Visit</label>
            <input
              type="date"
              name="next_visit_date"
              value={formData.next_visit_date || ''}
              onChange={handleChange}
              disabled={isDisabled}
            />
          </div>
        </div>
      </form>
    </div>
  );
};

export default PostAppointment;